export enum Result {
  Success,
  Fail
}